import { createSlice } from '@reduxjs/toolkit';
import { 
  getNotificationStats, 
  sendNotificationToAppUsers, 
  sendTestNotification 
} from '../auth/api';

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    stats: null,
    sendResult: null,
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setStats: (state, action) => {
      state.loading = false;
      state.error = null;
      state.stats = action.payload;
    },
    setSendResult: (state, action) => {
      state.loading = false;
      state.error = null;
      state.sendResult = action.payload;
    },
    clearSendResult: (state) => {
      state.sendResult = null;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { 
  setLoading, 
  setStats, 
  setSendResult,
  clearSendResult,
  setError,
  clearError 
} = notificationSlice.actions;

// Async thunk to fetch notification stats
export const fetchNotificationStatsAsync = (appId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await getNotificationStats(appId);
    dispatch(setStats(response.stats));
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

// Async thunk to send notification to all app users
export const sendNotificationAsync = (appId, notificationData) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await sendNotificationToAppUsers(appId, notificationData);
    dispatch(setSendResult(response));
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

// Async thunk to send test notification
export const sendTestNotificationAsync = (appId, testData) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const response = await sendTestNotification(appId, testData);
    dispatch(setSendResult(response));
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export default notificationSlice.reducer;
